"use client";
import { useTranslations } from "next-intl";
import MaintenanceItem from "./MaintenanceItem";
import Icon from "../../common/components/Icon";
import useCMSMaintenance from "../../cms/hooks/useCMSMaintenance";
import Loading from "../../common/components/Loading";

export const MaintenanceSection = ({ data }) => {
  const { label } = data || {};
  const { maintenance: items, loading } = useCMSMaintenance();
  const t = useTranslations();
  if (loading) return <Loading />;

  return (
    <>
      <h5 className="color-primary">{label}</h5>
      <div className="position-relative">
        {items?.length
          ? items?.map(({ from, to, text, _id }) => (
              <MaintenanceItem key={_id} text={text} from={from} to={to} />
            ))
          : t("no-maintenance-scheduled")}
      </div>
    </>
  );
};

export default MaintenanceSection;
